import { reactive, toRefs, computed, nextTick } from 'vue'
import { Message } from 'view-design'
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed, toPercent } from '@/common/js/filters'
import { setLocal, getLocal } from '@/common/js/api'
import { getNewDesignerPage, exportDesignerPersonalTableData } from '@/api/team.model'
// import { initDownloadCenterTask } from '@/api/report.model'

export const useDesignerTable = ({ dataType, getDateRange, buildFilterParams, getToken, tableRef }) => {
  const tableState = reactive({
    loading: null,
    pageIndex: 1,
    pageSize: parseInt(getLocal('PAGESIZE')) || 20,
    total: 0,
    sort: '',
    order: '',
    customColumnModal: false,
    exportLoading: false,
    tableHeight: 330,
    tableData: [],
    tableColumns: [],
    sumdata: [],
    existParams: {}
  })

  const tableCol = computed(() => tableState.tableColumns.filter((ret) => ret.checked))

  const getData = () => {
    const paramsForm = buildFilterParams() || {}
    const { dateType, ...opts } = paramsForm
    const [beginTime, endTime] = getDateRange()
    const params = {
      pageIndex: tableState.pageIndex,
      pageSize: tableState.pageSize,
      dataType: dataType.value,
      ...opts,
      beginTime,
      endTime,
      sort: tableState.sort,
      order: tableState.order
    }
    if (tableState.loading) return
    tableState.loading = true
    tableState.existParams = params
    getNewDesignerPage(params)
      .then((data) => {
        if (typeof data !== 'symbol') {
          tableState.loading = false

          if (!data) return
          const { list, page_info, sum_data } = data
          if (isArray(list) && page_info && sum_data) {
            const { total_number } = page_info
            tableState.sumdata = sum_data
            tableState.tableData = list
            tableState.total = total_number || 0
          } else {
            tableState.tableData = []
            tableState.total = 0
          }

          nextTick(() => {
            tableRef.value && tableRef.value.doLayout()
          })
        }
      })
      .catch(() => {
        tableState.loading = false
        tableState.tableData = []
        tableState.total = 0
      })
  }

  const changePageIndex = (index) => {
    tableState.pageIndex = index
    getData()
  }

  const changePageSize = (size) => {
    setLocal('PAGESIZE', size)
    tableState.pageIndex = 1
    tableState.pageSize = size
    getData()
  }

  const onQueryAction = () => {
    tableState.pageIndex = 1
    getData()
  }

  const onSortTable = ({ prop, order }) => {
    const orderType = {
      ascending: 'asc',
      descending: 'desc'
    }
    tableState.order = orderType[order]
    tableState.sort = prop
    tableState.pageIndex = 1
    getData()
  }

  const onExportTableData = (tableColumns, existParams) => {
    const { projectGroupId, gameGroupIds, gameIds, labelIdsStr, beginTime, endTime } = existParams
    const exportColumnOrderMap = {}
    tableColumns.forEach((col) => {
      if (col.checked && !col.exclude_export) {
        exportColumnOrderMap[col.key] = col.title
      }
    })
    const exportsParams = {
      sessionid: getToken(),
      beginTime,
      endTime,
      dataType: dataType.value,
      sort: tableState.sort,
      order: tableState.order,
      projectGroupId: projectGroupId > 0 ? projectGroupId : undefined,
      gameGroupIds: gameGroupIds?.length > 0 ? gameGroupIds : undefined,
      gameIds: gameIds?.length > 0 ? gameIds : undefined,
      labelIdsStr: labelIdsStr || undefined,
      exportColumnOrderMap
    }

    tableState.exportLoading = true
    exportDesignerPersonalTableData(exportsParams).then((data) => {
      if (data.msg) {
        Message.info(data.msg)
      }
    }).finally(() => {
      tableState.exportLoading = false
    })

    console.log('exportsParams output: ', exportsParams)
  }

  const tableRowValueRateToPercent = (row, key) => {
    return toPercent(row[key]) || '-'
  }

  const tableSummariesMethod = (param) => {
    const { columns } = param
    const data = JSON.parse(JSON.stringify(tableState.sumdata))
    const sums = []
    const twoDecimal = [
      'amount',
      'amount7',
      'newAmount',
      'totalAmount30',
      'createRoleCost',
      'newRoleMoney',
      'oneLevelKpi',
      'twoLevelKpi',
      'threeLevelKpi'
    ]
    columns.forEach((column, index) => {
      const prop = column.property
      if (index === 0) {
        sums[index] = '合计'
        return
      }
      if (prop.indexOf('Rate') > -1) {
        const val = parseFloat(data[prop])
        sums[index] = toPercentFixed(val)
      } else if (twoDecimal.includes(prop)) {
        const val = Number(data[prop])
        sums[index] = Object.is(NaN, val) ? '-' : toThousands(Number(val.toFixed(2)))
      } else {
        sums[index] = data[prop]
      }
    })
    return sums
  }

  const onTableColsChange = (cols) => {
    tableState.tableColumns = cols
    tableState.customColumnModal = false
  }

  return {
    ...toRefs(tableState),
    tableCol,
    getData,
    changePageIndex,
    changePageSize,
    onQueryAction,
    onSortTable,
    onExportTableData,
    tableRowValueRateToPercent,
    tableSummariesMethod,
    onTableColsChange
  }
}
